import { createSlice } from "@reduxjs/toolkit";
import {
  initStatePositionTracker,
  reducerPositionTracker,
} from "../actions/position-tracker/positionTracker";

export const initialState = {
  ...initStatePositionTracker,
};

export const positionTrackerSlice = createSlice({
  name: "positionTracker",
  initialState,
  reducers: {
    resetCreateProduct(state) {
      state.createProduct = initStatePositionTracker.createProduct;
    },
  },
  extraReducers: {
    ...reducerPositionTracker,
  },
});

export const { resetCreateProduct } = positionTrackerSlice.actions;
export const positionTrackerReducer = positionTrackerSlice.reducer;
